import React from 'react';
import { FormControl, Switch as Switch$1, FormLabel } from '@chakra-ui/react';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded = ["checked", "label"];

var Switch = function Switch(props) {
  var checked = props.checked,
      label = props.label,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  var tempId = "switch-" + Math.floor(Math.random() * 100);
  return React.createElement(FormControl, {
    d: "flex",
    alignItems: "center",
    w: rest.w || rest.width || 'full'
  }, React.createElement(Switch$1, Object.assign({
    id: tempId,
    isChecked: checked
  }, rest)), label && React.createElement(FormLabel, {
    m: "0",
    ml: "2",
    htmlFor: rest.id || tempId
  }, label));
};

export default Switch;